import { render, staticRenderFns } from "./addedit-lead.vue?vue&type=template&id=5e37239e&scoped=true"
import script from "./addedit-lead.vue?vue&type=script&lang=js"
export * from "./addedit-lead.vue?vue&type=script&lang=js"
import style0 from "./addedit-lead.vue?vue&type=style&index=0&id=5e37239e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e37239e",
  null
  
)

export default component.exports